import { RemoveRedEye } from "@mui/icons-material";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	styled,
} from "@mui/material";
import { getPreviewUrl } from "api/base";
import { Activity } from "api/types";
import { useState } from "react";

const PREFIX = "PreviewActivity";

const classes = {
	previewBtn: `${PREFIX}-previewBtn`,
	img: `${PREFIX}-img`,
};

const Root = styled("div")(({ theme }) => ({
	[`& .${classes.previewBtn}`]: {
		borderRadius: 50,
		padding: theme.spacing(1),
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
	},

	[`& .${classes.img}`]: {
		minWidth: "50%",
		minHeight: "50%",
	},
}));

export interface PreviewActivityProps {
	activity: Activity;
	handler: (item: Activity) => void;
}

export const PreviewActivity = ({
	activity,
	handler,
}: PreviewActivityProps): JSX.Element => {
	const [open, setOpen] = useState(false);
	const baseURL = getPreviewUrl(activity.questId);

	const handleClose = (): void => {
		setOpen(false);
	};

	const addToAssignment = (): void => {
		handler(activity);
		handleClose();
	};

	return (
		<Root>
			<Button
				variant="contained"
				color="primary"
				className={classes.previewBtn}
				onClick={() => setOpen(true)}
			>
				<RemoveRedEye /> Preview
			</Button>
			<Dialog open={open} onClose={handleClose}>
				<DialogTitle id="form-dialog-title">Preview</DialogTitle>
				<DialogContent>
					<img src={baseURL} alt="preview" className={classes.img} />
				</DialogContent>
				<DialogActions>
					<Button onClick={addToAssignment} color="primary">
						Add to assignment
					</Button>
				</DialogActions>
			</Dialog>
		</Root>
	);
};
